import { DepartureTimeExp, TicketType, TransportationMethod } from "./Constant";

export const toBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result.replace("data:", "").replace(/^.+,/, ""));
    reader.onerror = (error) => reject(error);
  });

export function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}

export function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

export function eraseCookie(name) {
  let d = new Date();
  d.setTime(d.getTime() - 1);
  let expires = "expires=" + d.toUTCString();
  document.cookie = `${name}=` + ";" + expires + ";path=/";
}

export function formatDate(date) {
  if (!date) return "";
  if (date === "0001-01-01T00:00:00") return "";
  let result = new Date(date);
  result = new Date(Date.UTC(result.getFullYear(), result.getMonth(), result.getDate(), result.getHours(), result.getMinutes()));
  return result.toISOString().slice(0, 10);
}

export function formatTime(time, upToSecs = false) {
  if (!time) return "";
  if (time === "0001-01-01T00:00:00") return "";
  let hours = new Date(time).getHours();
  let minutes = new Date(time).getMinutes();
  let secs = new Date(time).getSeconds();

  if (hours === 0) hours = "00";
  else if (hours < 10) hours = "0" + hours;

  if (minutes === 0) minutes = "00";
  else if (minutes < 10) minutes = "0" + minutes;

  if (secs === 0) secs = "00";
  else if (secs < 10) secs = "0" + secs;

  if (!upToSecs) return `${hours}:${minutes}`;
  else return `${hours}:${minutes}:${secs}`;
}

export function formatDepartureDate(departureDate, departureTime) {
  let date;
  let _departureDate = new Date(departureDate);
  let departureTimeReg = new RegExp(DepartureTimeExp);
  if (!departureTime.data && departureTimeReg.test(departureTime)) {
    _departureDate.setHours(Number(departureTime.substring(0, departureTime.indexOf(":"))));
    _departureDate.setMinutes(Number(departureTime.substring(departureTime.indexOf(":") + 1)));
    date = new Date(
      Date.UTC(_departureDate.getFullYear(), _departureDate.getMonth(), _departureDate.getDate(), _departureDate.getHours(), _departureDate.getMinutes())
    );
  } else {
    let _departureTime = new Date(departureTime.data ? departureTime.data : departureTime);
    date = new Date(
      Date.UTC(_departureDate.getFullYear(), _departureDate.getMonth(), _departureDate.getDate(), _departureTime.getHours(), _departureTime.getMinutes())
    );
  }
  return date;
}

export const getTrainStationOptions = (stations) => {
  let options = stations.map((option) => {
    let rObj = {};
    rObj["key"] = option.id;
    rObj["value"] = option.name;
    rObj["code"] = option.code;
    return rObj;
  });
  return options;
};

export const getStopOptions = (stations) => {
  let options = stations.map((option) => {
    let rObj = {};
    rObj["key"] = `${option.stopAreaName}-${option.zoneName}`;
    rObj["value"] = `${option.stopAreaName} (${option.zoneName})`;
    rObj["zone"] = `${option.zoneName}`;
    rObj["stopArea"] = `${option.stopAreaName}`;
    rObj["stopNumber"] = `${option.stopNumber}`;
    return rObj;
  });
  return options;
};

export const getLineOptions = (lines) => {
  let options = lines.map((option) => {
    let rObj = {};
    rObj["key"] = `${option.number}-${option.name}`;
    rObj["value"] = option.number == option.name ? option.number : `${option.number} (${option.name})`;
    rObj["number"] = `${option.number}`;
    rObj["name"] = `${option.name}`;
    return rObj;
  });
  return options;
};

export const getTrainStopOptions = (stations) => {
  let trainStations = [
    "Avesta busstation",
    "Arboga Resecentrum",
    "Fagersta Central",
    "Hallstahammar Jvstn",
    "Kolbäck Jvstn",
    "Kungsör järnvägsstation",
    "Köping jvstn",
    "Norbergs bstn",
    "Norbergs järnvägsstation",
    "Ramnäs Nya jvstn",
    "Ransta jvstn",
    "Skinnskatteberg jvstn",
    "Surahammar Jvstn",
    "Virsbo Jvstn",
    "Västerås Central",
    "Ängelsbergs Jvstn",
    "Eskilstuna Resecentrum",
  ];
  let options = stations
    .filter((option) => trainStations.includes(option.stopAreaName))
    .map((option) => {
      let rObj = {};
      rObj["key"] = `${option.stopAreaName}-${option.zoneName}`;
      rObj["value"] = `${option.stopAreaName} (${option.zoneName})`;
      rObj["zone"] = `${option.zoneName}`;
      rObj["stopArea"] = `${option.stopAreaName}`;
      return rObj;
    });
  return options;
};

export const getTicketTypeOptions = () => {
  return [
    {
      title: "movingo",
      ticketType: TicketType.COMMUTER,
    },
    {
      title: "single_ticket",
      ticketType: TicketType.SINGLE,
    },
  ];
};

export const getRefundTicketTypeOptions = () => {
  return [
    {
      title: "Resekort",
      ticketType: TicketType.COMMUTER,
    },
    {
      title: "other_ticket",
      ticketType: TicketType.OTHER,
    },
  ];
};

export const getSingleTicketTypeOption = () => {
  return {
    title: "single_ticket",
    ticketType: TicketType.SINGLE,
  };
};

export const getOtherTicketTypeOption = () => {
  return {
    title: "other_ticket",
    ticketType: TicketType.OTHER,
  };
};

export const getBusTransportationOption = () => {
  return {
    title: "transportation_bus",
    transportationMethod: TransportationMethod.BUS,
  };
};

export const getTrainTransportationOption = () => {
  return {
    title: "transportation_train",
    transportationMethod: TransportationMethod.TRAIN,
  };
};
